import { RenewalConfirmationTranslations } from '../types';

export const renewalConfirmation: RenewalConfirmationTranslations = {
  title: "Renouvellement Confirmé!",
  subtitle: "Merci de renouveler votre confiance en Gándara International School",
  submissionDetails: "Détails de Votre Renouvellement",
  parentName: "Père/Mère/Tuteur",
  childrenEnrolled: "Enfants Inscrits",
  submissionDate: "Date de Demande",
  referenceNumber: "Numéro de Référence",
  paymentInstructions: "Instructions de Paiement",
  bankAccount: "Compte Bancaire",
  accountNumber: "ES70 2100 5752 6202 0018 6824",
  recipient: "Bénéficiaire",
  recipientName: "NOGUERA Y VALDES SL",
  concept: "Concept du Paiement",
  amount: "Montant à Transférer",
  deadline: "Date Limite de Paiement",
  earlyBirdDeadline: "28 février 2026 (réduction anticipée)",
  standardDeadline: "17 mars 2026",
  pricingBreakdown: "Détail des Coûts",
  matriculaTotal: "Total Inscription",
  annualTuitionTotal: "Total Mensualités Annuelles (10 mois)",
  earlyBirdDiscount: "Réduction Inscription Anticipée",
  annualPaymentDiscount: "Réduction Paiement Annuel",
  grandTotal: "Total Général",
  nextSteps: "Prochaines Étapes",
  steps: {
    transfer: "Effectuez le virement bancaire avec les détails indiqués ci-dessus. N'oubliez pas d'inclure le concept exact pour que nous puissions identifier votre paiement.",
    sendConfirmation: "Envoyez la confirmation de paiement à info@gandaraschool.com",
    receiptConfirmation: "Nous confirmerons la réception de votre paiement dans un délai de 2 jours ouvrables",
    welcomeEmail: "Vous recevrez un e-mail de bienvenue en juin avec toutes les informations pour le début de l'année scolaire 2026/2027"
  },
  contactInfo: "Coordonnées",
  questionsContact: "Avez-vous des questions? Nous sommes là pour vous aider:",
  printConfirmation: "Imprimer la Confirmation",
  backToHome: "Retour à l'Accueil"
};
